import { IOffer } from 'types';
import { action } from 'typesafe-actions';
import { OfferActionTypes } from './types';
import { IImportOffer } from '../../types';

export const getActiveOffers = () => action(OfferActionTypes.GET_ACTIVE_OFFERS);
export const getActiveOffersSuccess = (offers: Array<IOffer>) =>
  action(OfferActionTypes.GET_ACTIVE_OFFERS_SUCCESS, { offers });
export const getActiveOffersFailure = (error: string) => action(OfferActionTypes.GET_ACTIVE_OFFERS_FAILURE, error);

export const setActiveOffer = (offer: IOffer | IImportOffer) => action(OfferActionTypes.SET_ACTIVE_OFFER, offer);
export const setActiveOfferSuccess = () => action(OfferActionTypes.SET_ACTIVE_OFFER_SUCCESS);
export const setActiveOfferFailure = (error: string) => action(OfferActionTypes.SET_ACTIVE_OFFER_FAILURE, error);
